/**
 * Real business details. Preserved from the pre-redesign Contact page — this
 * data appears nowhere in the Figma file and would otherwise have been lost.
 */
export const company = {
  name: 'NimblePark',
  tagline: 'Unlock performance with data-driven campaigns, creative storytelling, and impactful branding',
  email: 'info@nimblepark.com',
  phone: '+91 7926 4218 18',
  phoneHref: 'tel:+917926421818',
  address: '703, Saffron Park, Panchwati, Ahmedabad 380006',
  mapUrl: 'https://maps.google.com/?q=Saffron+Park+Panchwati+Ahmedabad+380006',
};

export const socials = [
  { id: 'twitter', label: 'X (formerly Twitter)', icon: 'twitter-x', href: '#' },
  { id: 'facebook', label: 'Facebook', icon: 'facebook', href: '#' },
  { id: 'instagram', label: 'Instagram', icon: 'instagram', href: '#' },
  { id: 'linkedin', label: 'LinkedIn', icon: 'linkedin', href: '#' },
];
